import { Component } from '@angular/core';
import { AddAllStockForm } from "../../../../components/admin-dashboard-component/add-all-stock-form/add-all-stock-form";

@Component({
  selector: 'app-add-all-stock',
  imports: [AddAllStockForm],
  templateUrl: './add-all-stock.html',
  styleUrl: './add-all-stock.scss'
})
export class AddAllStock {

}
